export default __webpack_public_path__ + "static/media/k5.f9a9a192.jpg";